<!--  -->
<template>
  <div class="">
    <div class="left">
      <div class="title">新墩概况</div>
      <div class="">
        <div class="flex alit">
          <div class="flex alit">
            <div class="left-one" style="margin-left: 8px; margin-right: 7px">
              新墩镇
            </div>
            <img
              class="jt"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E7%AE%AD%E5%A4%B4c.png"
              alt=""
            />
          </div>

          <div class="" style="flex: 1">
            <div class="flex justb" style="width: 100%; flex-wrap: wrap">
              <div class="left-gk-bg" v-for="item in xdzGk" :key="item.name">
                <div
                  class="flexCol"
                  style="margin-left: 33px; line-height: 30px"
                >
                  <div class="">{{ item.name }}</div>
                  <div class="flex">
                    {{ item.number }}
                    <a style="color: #47c2f1; margin-left: 5px">{{
                      item.unit
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex alit" style="margin-top: 5px">
          <div class="flex alit">
            <div class="left-two" style="margin-left: 8px; margin-right: 7px">
              双堡村
            </div>
            <img
              class="jt"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E7%AE%AD%E5%A4%B4b.png"
              alt=""
            />
          </div>
          <div class="" style="flex: 1">
            <div class="flex justb" style="width: 100%; flex-wrap: wrap">
              <div class="left-gk-bg" v-for="item in sbcGk" :key="item.name">
                <div
                  class="flexCol"
                  style="margin-left: 33px; line-height: 30px"
                >
                  <div class="">{{ item.name }}</div>
                  <div class="flex" style="color: #fab040">
                    {{ item.number }}
                    <a style="color: #47c2f1; margin-left: 5px">{{
                      item.unit
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title" style="margin: 15px 0 20px 0">种植预警</div>
      <div class="flex justc">
        <div class="zzyj-lv flexCol alit justc" @click="openCode(3)">
          <div class="yj-status" style="color: #16bc83">正常</div>
          <img
            src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/newHome/code/%E7%BB%BF%E7%A0%81.png"
            style="width: 66px; height: 66px"
            alt=""
          />
          <div class="zzyj-text">1</div>
        </div>
        <div
          class="zzyj-huang flexCol alit justc"
          style="margin: 0 24px"
          @click="openCode(2)"
        >
          <div class="yj-status" style="color: #ffc300">告警</div>
          <img
            src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/newHome/code/%E9%BB%84%E7%A0%81.png"
            style="width: 66px; height: 66px"
            alt=""
          />
          <div class="zzyj-text">1</div>
        </div>
        <div class="zzyj-hong flexCol alit justc" @click="openCode(1)">
          <div class="yj-status" style="color: #fa5252">异常</div>
          <img
            src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/newHome/code/%E7%BA%A2%E7%A0%81.png"
            style="width: 66px; height: 66px"
            alt=""
          />
          <div class="zzyj-text">0</div>
        </div>
      </div>
      <div class="title" style="margin-top: 20px">灌区信息</div>
      <div class="">
        <div class="flex justc" style="margin-top: 18px">
          <div class="left-gq1 flexCol justc">
            <div class="gq-text1">总灌溉量</div>
            <div class="flex">
              <div class="gq-text2">110万m³</div>
            </div>
          </div>
          <div class="left-gq2 flexCol justc" style="margin-left: 50px">
            <div class="gq-text1">亩均用水</div>
            <div class="flex">
              <div class="gq-text2">322m³</div>
            </div>
          </div>
        </div>
        <leftBottom style="height: 20vh"></leftBottom>
      </div>
    </div>
    <div class="center flex alit justc">
      <div class="flex alit justb top-data">
        <div class="flexCol alit">
          <div class="top-data-text1">
            占地面积<a style="font-size: 14px">(亩)</a>
          </div>
          <div class="top-data-text2">3426.83</div>
        </div>
        <div class="flexCol alit" >
          <div class="top-data-text1">
            物联设备<a style="font-size: 14px">(台)</a>
          </div>
          <div class="top-data-text2">645</div>
        </div>
        <div class="flexCol alit">
          <div class="top-data-text1">
            物资用量<a style="font-size: 14px">(吨)</a>
          </div>
          <div class="top-data-text2">232</div>
        </div>
        <div class="flexCol alit" >
          <div class="top-data-text1">
            估产<a style="font-size: 14px">(吨)</a>
          </div>
          <div class="top-data-text2">1649</div>
        </div>
        <div class="flexCol alit">
          <div class="top-data-text1">
            估值<a style="font-size: 14px">(万元)</a>
          </div>
          <div class="top-data-text2">1003</div>
        </div>
      </div>
      <maps :zoom="8"></maps>
      <div class="mengban"></div>
    </div>
    <div class="right">
      <div class="title">设备概况</div>
      <div class="" style="margin-top: 20px">
        <div class="flex justc">
          <div class="flexCol alit">
            <div class="gk-zxsbs-img">645</div>
            <div class="gk-zxsbs-text">在线设备数</div>
          </div>
          <div class="flexCol alit" style="margin: 0 50px">
            <div class="gk-zxl-img">100%</div>
            <div class="gk-zxl-text">在线率</div>
          </div>
          <div class="flexCol alit">
            <div class="gk-lxsbs-img">0</div>
            <div class="gk-lxsbs-text">离线设备数</div>
          </div>
        </div>
        <div class="flex justb" style="flex-wrap: wrap; width: 95%">
          <div
            class="device-list"
            v-for="item in deviceCount"
            :key="item.title"
            :style="{ backgroundImage: `url(${item.bg})` }"
          >
            <div class="device-num">{{ item.num }}</div>
            <div class="device-title">{{ item.title }}</div>
          </div>
        </div>
      </div>

      <div class="title" style="margin-top: 20px">物质用量</div>
      <div class="">
        <rightCenter style="height: 23vh"></rightCenter>
      </div>
      <div class="title" style="margin-top: 20px">产量分析</div>
      <div class="">
        <rightBottom style="height: 23vh"></rightBottom>
      </div>
    </div>

    <div class="dialog flexCol alit justc" v-if="dialogFmVisible">
      <div class="mask" @click="dialogFmVisible = false"></div>
      <div class="cont" style="background-color: #071f39; min-width: 30vw">
        <div class="zzym">
          种植预警<a :style="{ color: zzyjColor }">{{ zzyjTitle }}</a>
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="dialogFmVisible = false"
        />
        <div class="flexCol alit fertiliTable">
          <el-table
            style="background-color: transparent; width: 60vw"
            ref="singleTable"
            :data="tableData"
            :row-class-name="rowStyle"
            :header-row-class-name="headerstyle"
            max-height="700"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="itemName" label="项目名称" align="center">
            </el-table-column>
            <el-table-column prop="earlyType" label="预警类型" align="center">
            </el-table-column>
            <el-table-column prop="earlyInfo" label="预警信息" align="center">
            </el-table-column>
            <el-table-column prop="situation" label="预警时间" align="center">
              <template slot-scope="scope">{{
                utils.changeTime(scope.row.earlyTime)
              }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import maps from "../map.vue";
import leftBottom from "./leftBottom.vue";
import rightBottom from "./rightBottom2.vue";
import rightCenter from "./rightCenter.vue";
export default {
  components: { maps, leftBottom, rightBottom, rightCenter },
  data() {
    return {
      zzyjColor: "",
      zzyjTitle: "",
      tableData: [],
      dialogFmVisible: false,
      xdzGk: [
        {
          name: "行政村",
          number: "20",
          unit: "个",
        },
        {
          name: "总人口",
          number: "28944",
          unit: "人",
        },
        {
          name: "总耕地",
          number: "15103",
          unit: "亩",
        },
        {
          name: "高标建设",
          number: "7948.4",
          unit: "亩",
        },
      ],
      sbcGk: [
        {
          name: "人口",
          number: "1412",
          unit: "人",
        },
        {
          name: "高标农田",
          number: "3426.83",
          unit: "亩",
        },
        {
          name: "保鲜库",
          number: "0",
          unit: "吨",
        },
        {
          name: "塘坝",
          number: "70000",
          unit: "m³",
        },
      ],
      deviceCount: [
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%B0%B4%E9%98%80%E6%9C%BA.png",
          title: "水阀",
          num: "612个",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%B0%B4%E8%82%A5%E6%9C%BA.png",
          title: "水肥机",
          num: "4套",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%B0%94%E8%B1%A1%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "气象检测仪",
          num: "1套",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E8%99%AB%E6%83%85%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "虫情检测仪",
          num: "1套",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E8%8B%97%E6%83%85%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "苗情检测仪",
          num: "10套",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%AD%A2%E5%AD%90%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "孢子检测仪",
          num: "1套",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%9D%80%E8%99%AB%E7%81%AF.png",
          title: "杀虫灯",
          num: "15套",
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%9C%9F%E5%A3%A4%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "土壤检测仪",
          num: "10套",
        },
      ],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    headerstyle() {
      return "table-header";
    },
    rowStyle({ row, rowIndex }) {
      console.log(rowIndex);
      if (rowIndex % 2 == 0) {
        return "tabletrBg1";
      } else {
        return "tabletrBg2";
      }
    },
    openCode(e) {
      this.$request(`iot/screen/index/listCode?codeType=${e}`).then((res) => {
        console.log(res);
        this.tableData = res.data;
        this.dialogFmVisible = true;

        switch (e) {
          case 1:
            this.zzyjTitle = "(异常)";
            this.zzyjColor = "#fa5252";
            break;
          case 2:
            this.zzyjTitle = "(告警)";
            this.zzyjColor = "#ffc300";
            break;
          case 3:
            this.zzyjTitle = "(正常)";
            this.zzyjColor = "#16bc83";
            break;
          default:
            break;
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
/* 设置滚动条整体样式 */
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  /* 垂直滚动条宽度 */
}

/* 设置滚动条轨道 */
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  background: rgba(202, 199, 199, 0.1);
  /* 轨道背景色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置滚动条滑块 */
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #5d70db;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置鼠标悬停在滑块上的样式 */
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #5166db;
  cursor: pointer;
  /* 悬停时颜色 */
}
</style>
<style lang='scss' scoped>
.table-header {
  background: none !important;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E8%A1%A8%E6%A0%BC%E6%A0%87%E9%A2%98%402x.png") !important;
  background-size: 100% 100% !important;
}
.tabletrBg1 {
  background: rgba(35, 188, 249, 0.2) !important;
}
.tabletrBg2 {
  background: rgba(29, 111, 211, 0.178) !important;
}
.dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;
  .zzym {
    height: 65px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/title%402x.png");
    background-size: 100% 100%;

    font-family: YouSheBiaoTiHei;
    font-size: 26px;
    color: #ffffff;
    line-height: 65px;
    letter-spacing: 1px;
    text-align: center;
  }
  .dialog-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 99;
    cursor: pointer;
  }
  .mask {
    width: 100vw;
    height: 100vh;
    z-index: 1500;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
  }

  .cont {
    min-height: 700px;
    max-height: 800px;
    position: relative;
    z-index: 1501;
    background-color: #fff;
    border-radius: 20px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%BC%B9%E7%AA%97%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
  }
}
.top-data {
  width: 42%;
  position: fixed;
  top: 130px;
  /* left: 480px; */
  z-index: 99;

  .top-data-text1 {
    font-weight: 600;
    font-size: 18px;
    color: #addaff;
  }

  .top-data-text2 {
    font-family: YouSheBiaoTiHei;
    font-size: 39px;
    color: #fab040;
  }
}

.right {
  position: fixed;
  right: 20px;
  top: 10vh;
  width: 440px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  z-index: 98;

  .device-list {
    width: 100px;
    height: 50px;
    background-size: 100% 100%;
    margin-top: 25px;

    .device-num {
      font-family: DINAlternateBold;
      font-size: 16px;
      color: #ffffff;
      margin: 5px 0 5px 48px;
    }

    .device-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #ffffff;
      margin-left: 48px;
    }
  }

  .gk-zxsbs-img {
    width: 120px;
    height: 78px;

    font-family: DINAlternateBold;
    font-size: 26px;
    color: #07d59f;
    line-height: 40px;
    text-align: center;

    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E5%9C%A8%E7%BA%BF%E8%AE%BE%E5%A4%87.png");
    background-size: 100% 100%;
    background-position-y: 15px;
  }

  .gk-zxsbs-text {
    width: 100px;
    height: 30px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #07d59f;
    line-height: 30px;
    text-align: center;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%9C%A8%E7%BA%BF%E8%AE%BE%E5%A4%87%E6%95%B0%E5%AD%97.png");
    background-size: 100% 100%;
    margin-top: 3px;
  }

  .gk-zxl-img {
    width: 74px;
    height: 78px;

    font-family: DINAlternateBold;
    font-size: 26px;
    color: #ffffff;
    line-height: 104px;
    text-align: center;

    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/shuiqiu.png");
    background-size: 130% 130%;
    background-position-x: 60%;
    background-position-y: 50%;
  }

  .gk-zxl-text {
    width: 100px;
    height: 30px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #07d59f;
    line-height: 30px;
    text-align: center;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%9C%A8%E7%BA%BF%E7%8E%87%E5%AD%97.png");
    background-size: 100% 100%;
    margin-top: 3px;
  }

  .gk-lxsbs-img {
    width: 120px;
    height: 78px;

    font-family: DINAlternateBold;
    font-size: 26px;
    color: #07d59f;
    line-height: 40px;
    text-align: center;

    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E7%A6%BB%E7%BA%BF%E8%AE%BE%E5%A4%87.png");
    background-size: 100% 100%;
    background-position-y: 15px;
  }

  .gk-lxsbs-text {
    width: 100px;
    height: 30px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffd725;
    line-height: 30px;
    text-align: center;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E7%A6%BB%E7%BA%BF%E8%AE%BE%E5%A4%87%E5%AD%97.png");
    background-size: 100% 100%;
    margin-top: 3px;
  }
}

.left {
  position: fixed;
  left: 20px;
  top: 10vh;
  width: 440px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  z-index: 98;
  .jt {
    width: 33px;
    height: 33px;
    margin-left: -20px;
  }
  .left-one {
    width: 46px;
    height: 130px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%96%B0%E6%95%A6%E9%95%87%402x.png");
    background-size: 100% 100%;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #c7f1ff;
    writing-mode: vertical-lr;
    /* 垂直排列，从右到左 */
    letter-spacing: 4px;
    text-align: center;
    padding-left: 15px;
  }

  .left-two {
    width: 46px;
    height: 130px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%8F%8C%E5%A0%A1%E6%9D%91%402x.png");
    background-size: 100% 100%;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #c7f1ff;
    writing-mode: vertical-lr;
    /* 垂直排列，从右到左 */
    letter-spacing: 4px;
    text-align: center;
    padding-left: 15px;
  }

  .left-gk-bg {
    width: 140px;
    height: 60px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%A6%82%E5%86%B5%402x.png");
    background-size: 100% 100%;
    margin-top: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }

  .zzyj-lv {
    width: 118px;
    height: 161px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E7%BB%BF%402x.png");
    background-size: 100% 100%;
  }

  .zzyj-huang {
    width: 118px;
    height: 161px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E9%BB%84%402x.png");
    background-size: 100% 100%;
  }

  .zzyj-hong {
    width: 118px;
    height: 161px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E7%BA%A2%402x.png");
    background-size: 100% 100%;
  }

  .zzyj-text {
    font-family: DINAlternateBold;
    font-size: 27px;
    color: #ffffff;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    margin-top: 16px;
  }

  .yj-status {
    font-family: DINAlternateBold;
    font-size: 23px;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .left-gq1 {
    width: 180px;
    height: 53px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%80%BB%E7%81%8C%E6%BA%89%E9%87%8F%402x.png");
    background-size: 100% 100%;
  }

  .left-gq2 {
    width: 180px;
    height: 53px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E4%BA%A9%E5%9D%87%E7%81%8C%E6%BA%89%402x.png");
    background-size: 100% 100%;
  }

  .gq-text1 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-left: 60px;
  }

  .gq-text2 {
    font-family: DINAlternateBold;
    font-size: 20px;
    color: #ffffff;
    margin-left: 60px;
  }
}

.mengban {
  position: fixed;
  z-index: 97;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E9%A6%96%E9%A1%B5%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
}
</style>